'use client';

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useState } from 'react';
import { ImageSet } from '@/src/lib/product/types.ts';
import { Swiper } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import './slider.scss';
import ProductThumbsSlider from '@/src/app/[country]/[lang]/shop/[...segments]/(product-details)/components/ProductImageGallery/ProductThumbsSlider.tsx';
import ProductImageSlider from '@/src/app/[country]/[lang]/shop/[...segments]/(product-details)/components/ProductImageGallery/ProductImageSlider.tsx';
import ProductSliderImageItem from '@/src/app/[country]/[lang]/shop/[...segments]/(product-details)/components/ProductImageGallery/ProductSliderImageItem.tsx';
import Modal from '@/src/app/components/Modal/Modal.tsx';
import { Dictionary } from '@/src/lib/dictionary/types.ts';
type ProductGalleryProps = {
  productName: string;
  imageSet: ImageSet;
  dict: Dictionary;
  lang: string;
  country: string;
};
const SLIDER_IMAGE_ITEM_MAX_SIZE = 1400;
export const ModalContext = createContext({
  onClick: () => {}
});
function ProductImageGallery(t0) {
  const $ = _c(10);
  const {
    imageSet,
    productName,
    dict,
    lang,
    country
  } = t0;
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      onClick: () => setShowModal(true)
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== activeIndex || $[2] !== country || $[3] !== dict || $[4] !== imageSet || $[5] !== lang || $[6] !== productName || $[7] !== showModal || $[8] !== thumbsSwiper) {
    t2 = <ModalContext.Provider value={t1}>{imageSet.images.length === 1 ? <><ProductSliderImageItem url={imageSet.images[0].externalUrlLarge} alt={productName} width={640} height={640} priority={true} />{showModal ? <Modal dict={dict} lang={lang} country={country} onModalClose={() => setShowModal(false)}><ProductSliderImageItem url={imageSet.images[0].externalUrlLarge} alt={productName} useZoom={false} width={SLIDER_IMAGE_ITEM_MAX_SIZE} height={SLIDER_IMAGE_ITEM_MAX_SIZE} /></Modal> : null}</> : <><ProductImageSlider imageSet={imageSet} thumbsSwiper={thumbsSwiper} productName={productName} onActiveIndexChangeHandler={newActiveIndex => setActiveIndex(newActiveIndex)} key="slider" sliderClass="pdp-slider" enableKeyboard={!showModal} imageWidth={640} imageHeight={640} /><div className="z-20 absolute w-full bottom-[3.125rem] left-1/2 transform -translate-x-1/2 right-0 max-w-[43.125rem] px-5"><ProductThumbsSlider imageSet={imageSet} setThumbsSwiper={setThumbsSwiper} productName={productName} /></div>{showModal ? <Modal dict={dict} lang={lang} country={country} onModalClose={() => setShowModal(false)} simple={true}><ProductImageSlider sliderClass="pdp-modal-slider" imageSet={imageSet} productName={productName} initialSlide={activeIndex} imageHeight={SLIDER_IMAGE_ITEM_MAX_SIZE} imageWidth={SLIDER_IMAGE_ITEM_MAX_SIZE} useZoom={false} key="modal-slider" style={{
            maxWidth: `min(${SLIDER_IMAGE_ITEM_MAX_SIZE}px, calc(100vh - 8rem))`
          }} /></Modal> : null}</>}</ModalContext.Provider>;
    $[1] = activeIndex;
    $[2] = country;
    $[3] = dict;
    $[4] = imageSet;
    $[5] = lang;
    $[6] = productName;
    $[7] = showModal;
    $[8] = thumbsSwiper;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
export default ProductImageGallery;